import { getTableStartDate, getTableEndDate } from './summary_dws_table.js'
import { dateFromSecondsTimestamp, dateToTimeString, roundDateDownToNearest15MinIncrement, timestampSecsFromDate } from './common.js'
import { calculateSlotMarginAndWidth, setSlotMarginAndWidth } from './summary_dws_slot_render_helpers.js'
import { displayTimeRangeTooltip } from './summary_dws';

// SLOT DRAW FUNCTIONS

// Note: this is mostly copied from section draw functions to avoid unnecessary testing.
// TODO: Refactor, create common draw functions for slot and sections

function closeSlotDraw() {
  $("body").removeClass("slot-dragging-cursor");
  $(".dws-page-text").removeClass("text-unselectable")

  $(document).off('mousemove');
  $(document).off('mouseup');
}

function createMockSlotForDraw() {
  return `
    <div
      id="draw-slot"
      class="draw-slot"
    >
    <div>
  `
}

function handleSlotDrawMouseDown(event) {
  const clickTimeout = setTimeout(() => {
    $("body").addClass("slot-dragging-cursor");
    $(".dws-page-text").addClass("text-unselectable");

    const tableStartDate = getTableStartDate();
    const tableEndDate = getTableEndDate();
    const dropzoneElement = $(event.currentTarget);
    const dropzoneTS = parseInt(dropzoneElement.attr("data-timestamp")) + ((parseInt(dropzoneElement.attr("data-timestamp-offset")) / 1000))
    const mouseDownDate = dateFromSecondsTimestamp(dropzoneTS);

    // Set initial To time to be 15 minutes after From time.
    const to = dateFromSecondsTimestamp(dropzoneTS);
    to.setUTCMinutes(to.getUTCMinutes() + 15, 0, 0);
    $(`.slots-overlay.dropzone[data-user='${dropzoneElement.attr("data-user")}']`).append(createMockSlotForDraw());

    const {relativeMarginLeft, relativeSlotWidth, relativeMarginRight} = calculateSlotMarginAndWidth(
      {
        from: mouseDownDate,
        to
      },
      {
        from: tableStartDate,
        to: tableEndDate,
      },
    )

    const selector = "#draw-slot";
    setSlotMarginAndWidth(selector, relativeMarginLeft, relativeSlotWidth, relativeMarginRight);
    displayTimeRangeTooltip($(selector), dateToTimeString(mouseDownDate), dateToTimeString(to));

    $(document).on('mousemove', (mouseMoveEvent) => handleSlotDrawMouseMove(mouseMoveEvent, mouseDownDate, tableStartDate, tableEndDate));
    $(document).on('mouseup', (mouseUpEvent) => handleSlotDrawMouseUp(mouseUpEvent, event, mouseDownDate, tableStartDate, tableEndDate));
  }, 300)


  // Make sure draw won't activate if cell is clicked quickly
  $(document).on("mouseup", () => {
    clearTimeout(clickTimeout);
  })
}

function handleSlotDrawMouseMove(mouseMoveEvent, mouseDownDate, tableStartDate, tableEndDate) {
  const {from, to} = calculateSlotDrawFromAndTo(mouseMoveEvent, mouseDownDate, tableStartDate, tableEndDate);

  const {relativeMarginLeft, relativeSlotWidth, relativeMarginRight} = calculateSlotMarginAndWidth(
    {
      from,
      to,
    },
    {
      from: tableStartDate,
      to: tableEndDate,
    },
  );
  const selector = "#draw-slot";
  setSlotMarginAndWidth(selector, relativeMarginLeft, relativeSlotWidth, relativeMarginRight);
  displayTimeRangeTooltip($(selector), dateToTimeString(from), dateToTimeString(to));
}

function calculateSlotDrawFromAndTo(event, mouseDownDate, tableStartDate, tableEndDate) {
  const rowElement = $(".row-right-fixed");
  const {left, _} = rowElement.offset();
  const tableRowWidth = rowElement.width()
  const drawSlotRight = left + tableRowWidth;
  const mousePositionX = event.originalEvent.clientX;
  const tableStartDateInSeconds = tableStartDate.getTime() / 1000;
  const tableEndDateInSeconds = tableEndDate.getTime() / 1000;
  const tableLengthInSeconds = tableEndDateInSeconds - tableStartDateInSeconds;
  let from = mouseDownDate;
  let to;
  if (mousePositionX >= drawSlotRight) {
    to = tableEndDate;
  } else if (mousePositionX <= left) {
    from = tableStartDate;
    to = mouseDownDate;
  } else {
    const relativeSlotRight = (drawSlotRight - mousePositionX) / tableRowWidth;
    to = dateFromSecondsTimestamp(tableStartDateInSeconds + ((1 - relativeSlotRight) * tableLengthInSeconds));
    roundDateDownToNearest15MinIncrement(to);
    // If we start dragging from right to left, then switch the From and To
    if (to < from) {
      from = to;
      to = mouseDownDate;
    }
  }
  return {from, to};
}

function handleSlotDrawMouseUp(event, mouseDownEvent, mouseDownDate, tableStartDate, tableEndDate) {
  const userID = mouseDownEvent.currentTarget.dataset.user;
  const dateUnix = timestampSecsFromDate(mouseDownDate);
  // TODO: once openSlotModal can use timestamps for start and end, send timestamps instead of strings
  const {from, to} = calculateSlotDrawFromAndTo(event, mouseDownDate, tableStartDate, tableEndDate);
  const startTime = dateToTimeString(from);
  const endTime = dateToTimeString(to);

  openSlotModal(dateUnix, userID, null, {startTime, endTime});
  closeSlotDraw();
}

export function initSlotDraw() {
  $('.cell-dws.dropzone').on('mousedown', (event) => handleSlotDrawMouseDown(event))
}